import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';

import { Store } from '@ngrx/store';

import { TellentCurrentUserSelectors } from '@core/tellent-data';
import {
  HELP_DROPDOWN_CONFIG,
  HelpDropdownComponent,
  HelpDropdownService,
  TellentAdoptedStylesheetsDirective,
  TellentThemeDirective,
} from '@core/tellent-smart-ui';
import { InputSignalLike, TellentWebComponent } from '@core/tellent-types';

@Component({
  selector: 'x-help-dropdown',
  template: `
    <tlc-help-dropdown
      [showGetStarted]="showGetStarted()"
      [isActive]="isActive()"
      [isUnread]="helpDropdownService.hasUnreadUpdates()"
      (chatWithUs)="chatWithUs.emit()"
      (getStarted)="getStarted.emit()"
      (productUpdatesClick)="onProductUpdatesClick()"
    />
  `,
  styleUrls: ['../../../styles.less'],
  styles: `
    :host {
      display: inline-block;
      position: relative;
    }
  `,
  hostDirectives: [TellentThemeDirective, TellentAdoptedStylesheetsDirective],
  imports: [HelpDropdownComponent],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: HELP_DROPDOWN_CONFIG,
      useFactory: () => ({
        userId: inject(Store).selectSignal(TellentCurrentUserSelectors.data)()?.guid ?? '',
      }),
    },
    HelpDropdownService,
  ],
})
export class TellentHelpDropdownWrapComponent {
  public readonly helpDropdownService = inject(HelpDropdownService);

  public showGetStarted: InputSignalLike<boolean> = input(true);
  public isActive: InputSignalLike<boolean> = input(false);

  public chatWithUs = output<void>();
  public getStarted = output<void>();
  public productUpdatesClick = output<void>();

  protected onProductUpdatesClick(): void {
    this.helpDropdownService.markAsSeen();
    this.productUpdatesClick.emit();
  }
}

export type TellentHelpDropdownWebComponent = TellentWebComponent<
  TellentHelpDropdownWrapComponent,
  'showGetStarted' | 'isActive' | 'chatWithUs' | 'getStarted' | 'productUpdatesClick'
>;
